import React from 'react'
import { makeStyles } from '@material-ui/core'
import ProfilePicture from 'components/common/ProfilePicture'
import Tooltip from 'components/common/Tooltip'
import usePatientPresence from 'hooks/usePatientPresence'

const useStyles = makeStyles({
  container: { display: 'flex', alignItems: 'center' },
  overflow: { fontSize: 11, fontWeight: 600, color: 'var(--text-color-11)', marginLeft: 2 }
})

const PatientPresenceMarker = ({ patientId }) => {
  const classes = useStyles()
  const presence = usePatientPresence(patientId)

  if (!presence) {
    return null
  }

  const { primary, overflowCount, tooltip } = presence

  return (
    <Tooltip value={tooltip} variant="dark" arrow placement="top">
      <div className={classes.container}>
        <ProfilePicture photo={primary.photo} name={primary.name} size="xsmall" />
        {overflowCount > 0 && <span className={classes.overflow}>+{overflowCount}</span>}
      </div>
    </Tooltip>
  )
}

export default PatientPresenceMarker
